import isServer from '@anm/helpers/is/isServer';

var isMobile = function isMobile() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isServer() && window.navigator.userAgent;
  return !!userAgent && /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/gi.test(userAgent);
};

export default isMobile;